import { useQuery } from 'react-query'
import { addQueryParamsToApiV2 } from '@/root/helpers'
import { fetchPOSTRequest } from '@/root/utils/network-adapter/fetch-request'

type TpriceData = {
  prices: Array<{
    ind_id: string
    current_price: number
    '1d_change': number
    '1d_perc_change': number
    last_updated_v2?: string
  }>
}

export default function useLivePrice({
  ticker,
  currency,
  apiUrl,
  isMarketOpen,
}: {
  ticker?: string
  currency?: string
  apiUrl?: string
  isMarketOpen?: boolean
}) {
  const { data: pricePollingData } = useQuery<TpriceData>(
    ['livePrice', ticker, currency],
    () =>
      fetchPOSTRequest({
        url: addQueryParamsToApiV2(apiUrl ?? '', {
          ...(currency ? { currency } : {}),
        }),
        headers: {
          'Content-Type': 'text/plain',
        },
        data: {
          ind_ids: [ticker?.toUpperCase()],
        },
      }),
    {
      refetchInterval: 5000,
      enabled: !!ticker && !!apiUrl && isMarketOpen,
    },
  )

  const livePriceData = {
    livePrice: pricePollingData?.prices?.[0]?.current_price,
    dayChange: pricePollingData?.prices?.[0]?.['1d_change'],
    dayChangePercentage: pricePollingData?.prices?.[0]?.['1d_perc_change'],
    lastUpdated: pricePollingData?.prices?.[0]?.last_updated_v2,
  }

  return livePriceData
}
